import { render, staticRenderFns } from "./rescue-order-price.vue?vue&type=template&id=771f0683"
import script from "./rescue-order-price.vue?vue&type=script&lang=js"
export * from "./rescue-order-price.vue?vue&type=script&lang=js"
import style0 from "./rescue-order-price.vue?vue&type=style&index=0&id=771f0683&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports